import { VIDEO_FILE_PATH } from '../../constants/pathConstants'
import { userStateData } from '../../data/userStateData'
import { useAppDispatch } from '../../redux/hooks'
import { setShowWatchVideos } from '../../redux/reducers/chatSlice'
import './style.scss'


// interface WatchVideoProps {
// 	videoUrls: string[]
// }

// function WatchVideo({videoUrls}: WatchVideoProps) {
function WatchVideo() {

	const dispatch = useAppDispatch()

	const closeButtonClickHandler = () => {
		dispatch(setShowWatchVideos(false))
	}

	return (
		<div className="watch-videos-wrap">
			<div className='watch-videos-content-wrap'>
				<div className='watch-videos-content-title'>Watch Videos</div>
				{/* <div className='watch-videos-content-video-item-wrap'>
					<div className='watch-videos-content-video-item'>
						<img
							className='watch-videos-content-video-play-button'
							src='/imgs/icons/icon-play-video-button.svg'
							alt='play button'
						/>
					</div>
				</div> */}
				<video 
					id="example_video_1"
					className="video-js vjs-default-skin"
					width="600"
					height="264"
					src={`${VIDEO_FILE_PATH}${userStateData.videoFileName}`}
					typeof='video/mp4'
					controls
				/>
				<button
					className='watch-video-close-button'
					onClick={() => closeButtonClickHandler()}
				>
					<img
						className='watch-video-close-button-img'
						src='/imgs/icons/icon-faq-plus.svg'
						alt='close button'
					/>
				</button>
			</div>
		</div>
	)
}

export default WatchVideo
